import { NgModule, Component, Input } from '@angular/core';

@Component({
    selector: 'contentloader',
    templateUrl: './contentloader.html',
    styleUrls: ['./contentloader.scss'],
    standalone: false
})
export class ContentloaderComponent {
    @Input() showTitle:boolean = true;
    @Input() title:string = "Loading";
    @Input() secondTitle:string;
}
